import client from './client';

export interface LlmModelOption {
  id: string;
  label: string;
  context_length: number;
  input_cost_per_million?: number | null;
  output_cost_per_million?: number | null;
  structured_output: boolean;
  provider_endpoints: string[];
}

export interface LlmModelSource {
  id: 'google' | 'openai' | 'openrouter';
  label: string;
  configured: boolean;
  region?: string | null;
  zero_data_retention: boolean;
  data_collection: string;
  models: LlmModelOption[];
}

export interface LlmJobRow {
  id: string;
  label: string;
  group: string;
  description: string;
  default_model: string;
  model: string;
  provider: string;
  source: string;
  family: string;
  role: string;
  cost_7d_usd?: number;
  calls_7d?: number;
  cost_mtd_usd?: number;
  calls_mtd?: number;
}

export interface LlmJobsResponse {
  jobs: LlmJobRow[];
  sources: LlmModelSource[];
}

export const getLlmJobs = async (): Promise<LlmJobsResponse> => {
  const response = await client.get<LlmJobsResponse>('/api/v1/llm-jobs');
  return response.data;
};
